import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { IApplicationSetting } from '@interfaces/application-setting';
import { Observable, Subscription, take } from 'rxjs';
import { ApplicationSettingsState } from '@store/application-settings.state';
import { Store } from '@ngxs/store';
import { GetApplicationSettings } from '@store/application-settings.action';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { SubscribeNewsletterSmallComponent } from '../subscribe-newsletter-small/subscribe-newsletter-small.component';
import { ReplaceHostDirective } from '../../directives/replace-host/replace-host.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [RouterLinkActive, RouterLink, SubscribeNewsletterSmallComponent, ReplaceHostDirective, TranslatePipe]
})
export class FooterComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  private store = inject(Store);
  private applicationSettings$: Observable<IApplicationSetting[] | undefined> = this.store.select(ApplicationSettingsState.getApplicationSettings);

  public siteName = environment.companyName;
  public year = new Date().getFullYear();
  public whatsAppUrl?: string;

  public ngOnInit(): void {
    this.subscriptions.push(
      this.applicationSettings$.subscribe(applicationSettings => {
        this.whatsAppUrl = applicationSettings?.find(setting => setting.label === 'WhatsAppUrl')?.value;
      })
    );

    this.applicationSettings$.pipe(take(1)).subscribe((applicationSettings) => {
      if (!applicationSettings) {
        this.store.dispatch(new GetApplicationSettings());
      }
    });
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
